import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';

interface IProps {
  width?: number;
  style?: StyleProp<ViewStyle>;
}

export default (props: IProps) => {
  const {width: size} = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="17.3433" cy="17.5" rx="17.3433" ry="17.5" fill="#0088FF" />
      <path
        d="M22.2103 20.6361C23.2996 19.1495 23.7874 17.3063 23.5763 15.4754C23.3652 13.6444 22.4706 11.9607 21.0715 10.7611C19.6725 9.56151 17.8721 8.93446 16.0307 9.00543C14.1892 9.07639 12.4425 9.84013 11.1399 11.1439C9.83725 12.4476 9.07486 14.1951 9.00523 16.0369C8.93559 17.8787 9.56384 19.6788 10.7643 21.0772C11.9647 22.4756 13.6488 23.3691 15.4797 23.579C17.3105 23.7888 19.1531 23.2995 20.6387 22.209H20.6376C20.6713 22.254 20.7073 22.2968 20.7478 22.3384L25.0789 26.6701C25.2898 26.8812 25.576 26.9999 25.8744 27C26.1728 27.0001 26.4591 26.8816 26.6702 26.6707C26.8812 26.4597 26.9999 26.1735 27 25.8751C27.0001 25.5766 26.8817 25.2903 26.6707 25.0792L22.3396 20.7475C22.2994 20.7068 22.2562 20.6703 22.2103 20.6361ZM22.5005 16.3112C22.5005 17.1238 22.3405 17.9285 22.0295 18.6793C21.7186 19.43 21.2628 20.1122 20.6883 20.6868C20.1138 21.2615 19.4317 21.7173 18.681 22.0283C17.9303 22.3392 17.1258 22.4993 16.3132 22.4993C15.5007 22.4993 14.6961 22.3392 13.9455 22.0283C13.1948 21.7173 12.5127 21.2615 11.9382 20.6868C11.3636 20.1122 10.9079 19.43 10.5969 18.6793C10.286 17.9285 10.126 17.1238 10.126 16.3112C10.126 14.67 10.7778 13.096 11.9382 11.9355C13.0985 10.775 14.6723 10.123 16.3132 10.123C17.9542 10.123 19.528 10.775 20.6883 11.9355C21.8486 13.096 22.5005 14.67 22.5005 16.3112Z"
        fill="white"
      />
    </svg>
  );
};
